

var _globalHistory;

export function setGlobalHistory(history) {
    _globalHistory = history;
}

export function navigate(path) {
    _globalHistory.push(path);
}

export const paths = {
    login: '/login',
    home:'/home',
    error_page:'/error',
    landing_page: '/landing-page',
    register: '/register',
    register_existing: '/register-existing', 
    register_identify: '/register-identify', 
    reset_password: '/reset-password',
    setting: '/setting',
    subcriptions: '/subcriptions',    
    bills: '/bills',
    support: '/support',
    package_info: '/package',
    support_add: '/support-add',
    notifications: '/notifications',
    notifications_detail: '/notifications-detail',
    bill_detail: '/bill-detail',
    swap_service: '/swap-service',
    orders_result: '/registerorders-result',
    package_contact: '/package-contact',
    reorders_result: '/registerreorders-result',
    change_service_result: '/changeservice-result',
    vumatel_sms: '/vumatel/sms',
    vumatel_retry_payment: '/vumatel/retrypayment',
    vumatel_renew_payment: '/vumatel/renewpayment',
    vumatel_update_card: '/vumatel/updatecard',
    payment_result: "/payment-result",
    invoices: '/invoices',
    vumatel_paymentlink: '/vumatel/sms/paymentlink',
    openserve_paymentlink: '/openserve/sms/paymentlink',
    octotel_paymentlink: '/octotel/sms/paymentlink',
    metrofibre_paymentlink: '/metrofibre/sms/paymentlink',
    paymentlink: "/paymentlink"
}
/**
 * route permission configuration
 * <path> : [scope, access list of <indicator|merchant type|group> : <read write permission>
 * - path: use predefined path
 * - scope: 
 *      + _IN_SESSION - only use if a session exists
 *      + _IN_OUT_SESSION  - can be used without a session
 *      + _OUT_SESSION - only used without a session - usedWithSession will be ignored
 * - access list:
 *      + < indicator|merchant type|group > -> if a user profile does not have its combination exist -> no access at all
 *      + read write permission: r - read, w - write, e.g. rw. 
 *      + indicator value: A - aggregated, M - master merchant, T - third party agent
 *      + merchant type (when indicator = M): H - HQ, S - Sub merchant, M - master merchant (agent), HS - HQ and sub merchant
 *      + group: ADMIN, TEAMMGR, AGENT, USR, MANAGER = MGR ?
 * 
 * NOTE: Read/Write permission is acting so far only as a reference. To show/hide a button use actions configuration
 */

const _IN_SESSION = 0;
const _OUT_SESSION = 2;
const _IN_OUT_SESSION = 3;

export const SCOPE = {
    _IN_SESSION,
    _OUT_SESSION,
    _IN_OUT_SESSION
}

export const routeACL = {
    [paths.login]: _OUT_SESSION,
    [paths.home]: _IN_SESSION,
}


